// extracted by mini-css-extract-plugin
export default {"control":"II3rk","controlWithSpace":"zi9wU","controlVertical":"YDusp","controlHorizontal":"B2TWS","label":"zTmpV","labelRequired":"BQP9_","error":"BalzD","errorText":"c8YPm"};